"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsignationOption = void 0;

var _styles = require("./styles");

var _Avatar = require("../Avatar");

var _removeAsigned = _interopRequireDefault(require("../../../assets/images/asignationOptions/removeAsigned.svg"));

var _requestToProvider = _interopRequireDefault(require("../../../assets/images/asignationOptions/requestToProvider.svg"));

var _requestToTeam = _interopRequireDefault(require("../../../assets/images/asignationOptions/requestToTeam.svg"));

var _availableIcon = _interopRequireDefault(require("../../../assets/images/asignationOptions/availableIcon.svg"));

var _data = require("../../../global-files/data");

var _Status = require("../../atoms/Status");

var _jsxRuntime = require("react/jsx-runtime");

var AsignationOption = function AsignationOption(_ref) {
  var profileImage = _ref.profileImage,
      _ref$asignationType = _ref.asignationType,
      asignationType = _ref$asignationType === void 0 ? "available" : _ref$asignationType,
      _ref$imageType = _ref.imageType,
      imageType = _ref$imageType === void 0 ? "profile-image" : _ref$imageType,
      name = _ref.name,
      team = _ref.team,
      onClick = _ref.onClick,
      btnOnClick = _ref.btnOnClick,
      active = _ref.active,
      services = _ref.services;

  var getStatus = function getStatus() {
    var servCad = "";
    services.forEach(function (srv) {
      return servCad += srv;
    });
    return (0, _data.getNewStatus)(services);
  };

  var iconsAsignation = {
    assigned: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      onClick: btnOnClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _removeAsigned.default,
        alt: "remove asigned"
      })
    }),
    provider: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _requestToProvider.default,
      alt: "Solicitar a Proveedor"
    }),
    team: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _requestToTeam.default,
      alt: "Solicitar a Team"
    }),
    available: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _availableIcon.default,
      alt: "green circle icon"
    })
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    onClick: onClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
      imageType: imageType,
      image: profileImage,
      altText: "profile image"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "labels-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "name-label",
        children: name
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "team-label",
        children: team
      })]
    }), asignationType && iconsAsignation[asignationType], services && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "status-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Status.Status, {
        statusType: getStatus()
      })
    }), active && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "green-circle"
    })]
  });
};

exports.AsignationOption = AsignationOption;